import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    // External dependencies
    CommonModule,
    RouterModule,
  ],
  declarations: [],
  exports: [],
})
export class EventManagerModule {}
